import { Box, Heading, BoxProps, Text, Flex, Button } from '@chakra-ui/react';
import { colors, elevation } from 'constants/constants';
import React from 'react';
import Image from 'next/image';
import { Discount, ProductDto } from 'types/generic';
import { useRouter } from 'next/router';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { calcProductImageFromSize } from 'helpers/productHelpers';
import { getBestDiscount, getDiscountPrice } from 'helpers/discounts';
import DiscountPrice from 'components/campaigns/DiscountPrice';

export interface ProductCardProps extends BoxProps {
  product: ProductDto;
  facilityId: number;
  discounts: Discount[];
}

function ProductCard({ product, facilityId, discounts }: ProductCardProps): JSX.Element {
  const router = useRouter();
  function goToCheckout() {
    router.push({
      pathname: '/checkout',
      query: { p: product.id, f: facilityId },
    });
  }

  const objSize = calcProductImageFromSize(product.size);
  const filteredDiscounts = discounts.filter(discount => discount.appliesToProductId.includes(product.id))
  let discountPrice = 0
  if (filteredDiscounts.length > 0) {
    discountPrice = getDiscountPrice(product.price, getBestDiscount(product.price, filteredDiscounts))
  }

  const shouldShowHeading = product.name.includes('m3') || product.name.includes('Entréplan')

  let displayName = product.name;
  if (displayName.includes('Entréplan')) {
    displayName = displayName.substring(0, displayName.indexOf('Entréplan') + 'Entréplan'.length);
  }

  return (
    <Box
      onClick={goToCheckout}
      _hover={{ transform: 'translateY(-.3em)', boxShadow: elevation['+80'] }}
      transition=".15s all ease-in-out"
      cursor="pointer"
      w="100%"
      bg={colors.white}
      boxShadow={elevation['+20']}
      borderRadius=".2em"
      overflow="hidden">
      <Flex justify="center" bg={colors.secondary[50]} mt="-20px">
        <Box transform="translateY(40px)">
          <Image
            src={`/images/objects/${objSize}.svg`}
            alt={`förråd ${product.size} kvadratmeter`}
            width={200}
            height={200}
          />
        </Box>
      </Flex>
      <Box p="1.5em">
        <Box>
          <Heading as="h3" variant="productCardHeading">
            {product.size} m²
          </Heading>
          {shouldShowHeading && <Heading as="h3" variant="productCardHeading">
            ({displayName})
          </Heading>}
        </Box>


        <Flex justifyContent="space-between" align="center">
          <Box mt={3}>

            {(discountPrice > 0 && filteredDiscounts.length > 0) ?
              <DiscountPrice price={product.price} discount={getBestDiscount(product.price, filteredDiscounts)} /> :
              <Text variant="productCardMoney">{product.price}:-/mån</Text>}
          </Box>
        </Flex>
        <Flex justifyContent="space-between" align="center">
          <Box mt={3}>
              <Text>{product.description}</Text>
          </Box>
          <Button
            rightIcon={<ChevronRightIcon />}
            fontWeight="normal"
            aria-label="Välj produkt"
            variant="ml"
            onClick={goToCheckout}>
            Boka
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
export default ProductCard;
